export const persistStateToUrl = ({
  filters,
  sortKey,
  sortDirection,
  page,
  pageSize,
  setSearchParams,
}) => {
  const params = {};

  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (
        value !== null &&
        value !== '' &&
        !(Array.isArray(value) && value.length === 0)
      ) {
        params[key] = Array.isArray(value) ? value.join(',') : String(value);
      }
    });
  }

  if (sortKey) params.sortKey = sortKey;
  if (sortDirection) params.sortDir = sortDirection;
  if (page !== undefined) params.page = page;
  if (pageSize !== undefined) params.pageSize = pageSize;

  setSearchParams(params);
};
